module.exports = __webpack_public_path__ + "img/logo.ad695278.svg";